// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_container__TsUVY {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  display: flex;
  justify-content: space-between;
  left: 0;
  margin: 0 auto;
  padding-top: 26px;
  position: relative;
  right: 0;
  top: 0;
  width: 95%;
  z-index: 1;
}
.Header_container__TsUVY .Header_left__AgymK {
  align-items: center;
  display: flex;
  gap: 40px;
}
.Header_container__TsUVY .Header_left__AgymK .Header_nav__IIF23 {
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 24px;
}
.Header_container__TsUVY .Header_left__AgymK .Header_nav__IIF23 .Header_selected__VXj\\+1 {
  color: #ead40c;
}
.Header_container__TsUVY .Header_right__sCxx3 {
  display: flex;
  gap: 24px;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_lang__KB6aX {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  gap: 4px;
  display: flex;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_lang__KB6aX .Header_langItem__3jV-\\+ {
  cursor: pointer;
  transition: all 0.2s linear;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_yellow__3Tl\\+p {
  color: #ead40c;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_btn__WHq\\+I {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  border-radius: 8px;
  cursor: pointer;
  padding: 10px 22px;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_btns__KvSb0 {
  align-items: center;
  display: flex;
  gap: 24px;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_auth__N\\+DeY {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #ead40c;
  display: flex;
  gap: 20px;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_auth__N\\+DeY .Header_line__vI3iU {
  background-color: #e0e0e0;
  height: 32px;
  width: 1px;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_auth__N\\+DeY .Header_profile__rt0Qw {
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 8px;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_auth__N\\+DeY .Header_profile__rt0Qw .Header_profileImg__mF4pB {
  width: 48px;
}
.Header_container__TsUVY .Header_right__sCxx3 .Header_enter__ukbRm {
  background-color: #333217;
  color: #ead40c;
}
.Header_container__TsUVY .Header_hoverY__pjuff {
  transition: all 0.2s linear;
}
.Header_container__TsUVY .Header_hoverY__pjuff:hover {
  color: #FD4C0A;
}

@media (max-width: 1100px) {
  .Header_container__TsUVY {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_mixins.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;ECmCE,eAAA;EACA,gBAAA;EACA,kBAAA;EDlCA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,OAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;AAAF;AAEE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AAAJ;AAEI;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAAN;AAEM;EACE,cAAA;AAAR;AAKE;EACE,aAAA;EACA,SAAA;AAHJ;AAKI;ECKF,eAAA;EACA,gBAAA;EACA,kBAAA;EDJI,mBAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;AAFN;AAIM;EACE,eAAA;EACA,2BAAA;AAFR;AAMI;EACE,cAAA;AAJN;AAOI;ECPF,eAAA;EACA,gBAAA;EACA,kBAAA;EDQI,kBAAA;EACA,eAAA;EACA,kBAAA;AAJN;AAOI;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AALN;AAQI;ECjCF,eAAA;EACA,gBAAA;EACA,kBAAA;EDkCI,mBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AALN;AAOM;EACE,yBAAA;EACA,YAAA;EACA,UAAA;AALR;AAQM;EACE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;AANR;AAQQ;EACE,WAAA;AANV;AAWI;EACE,yBAAA;EACA,cAAA;AATN;AAaE;EE1EA,2BAAA;AFgEF;AE9DE;EACE,cCtBO;AHsFX;;AAYA;EACE;IACE,aAAA;EATF;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.container {\n  @include subtitle4m;\n\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  left: 0;\n  margin: 0 auto;\n  padding-top: 26px;\n  position: relative;\n  right: 0;\n  top: 0;\n  width: 95%;\n  z-index: 1;\n\n  .left {\n    align-items: center;\n    display: flex;\n    gap: 40px;\n\n    .nav {\n      align-items: center;\n      color: #ffffff;\n      display: flex;\n      gap: 24px;\n\n      .selected {\n        color: #ead40c;\n      }\n    }\n  }\n\n  .right {\n    display: flex;\n    gap: 24px;\n\n    .lang {\n      @include subtitle5;\n\n      align-items: center;\n      color: #ffffff;\n      gap: 4px;\n      display: flex;\n\n      .langItem {\n        cursor: pointer;\n        transition: all 0.2s linear;\n      }\n    }\n\n    .yellow {\n      color: #ead40c;\n    }\n\n    .btn {\n      @include subtitle6m;\n\n      border-radius: 8px;\n      cursor: pointer;\n      padding: 10px 22px;\n    }\n\n    .btns {\n      align-items: center;\n      display: flex;\n      gap: 24px;\n    }\n\n    .auth {\n      @include subtitle4m;\n\n      align-items: center;\n      color: #ead40c;\n      display: flex;\n      gap: 20px;\n\n      .line {\n        background-color: #e0e0e0;\n        height: 32px;\n        width: 1px;\n      }\n\n      .profile {\n        align-items: center;\n        color: #ffffff;\n        display: flex;\n        gap: 8px;\n\n        .profileImg {\n          width: 48px;\n        }\n      }\n    }\n\n    .enter {\n      background-color: #333217;\n      color: #ead40c;\n    }\n  }\n\n  .hoverY {\n    @include hoverYellow;\n  }\n}\n\n@media (max-width: 1100px) {\n  .container {\n    display: none;\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","@mixin df {\n  display: flex;\n}\n\n@mixin df-aic {\n  align-items: center;\n  display: flex;\n}\n\n@mixin df-aic-g8 {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n@mixin df-aic-jcc {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n@mixin df-aic-jcsb {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n@mixin hoverYellow {\n  transition: all .2s linear;\n\n  &:hover {\n    color: $c-yellow;\n  }\n}\n\n@mixin borderYellow {\n  border: 1px solid $c-yellow;;\n  transition: all .2s linear;\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header_container__TsUVY`,
	"left": `Header_left__AgymK`,
	"nav": `Header_nav__IIF23`,
	"selected": `Header_selected__VXj+1`,
	"right": `Header_right__sCxx3`,
	"lang": `Header_lang__KB6aX`,
	"langItem": `Header_langItem__3jV-+`,
	"yellow": `Header_yellow__3Tl+p`,
	"btn": `Header_btn__WHq+I`,
	"btns": `Header_btns__KvSb0`,
	"auth": `Header_auth__N+DeY`,
	"line": `Header_line__vI3iU`,
	"profile": `Header_profile__rt0Qw`,
	"profileImg": `Header_profileImg__mF4pB`,
	"enter": `Header_enter__ukbRm`,
	"hoverY": `Header_hoverY__pjuff`
};
export default ___CSS_LOADER_EXPORT___;
